export const exly_source_header = { "exly-source": "exly_connect" };
export const scoot_origin_header = { "scoot-origin": "web_app" };
